<template>
  <div class = "Index" :class="{ 'SidebarCollapsed': !isSidebarOpen }">
    <!-- 标题 -->
    <div class = "Title">
      <div class = "Logo">
        <div @click="ToggleSidebar" :title="isSidebarOpen ? '收起侧边栏' : '展开侧边栏'" style="cursor: pointer; padding-right: 15px; display: flex; align-items: center;">
          <img :src="isSidebarOpen ? '/icon/CRMEB-收起侧边栏-面性.svg' : '/icon/CRMEB-展开侧边栏-面性.svg'" width="20" height="20" />
        </div>
        <div @click="GoToIndex" style="cursor: pointer;"><img src = "/icon/logo.svg" style = "width: 20px;"></div>
        <div class = "Name" style = "font-size: 15px; font-weight: 900; cursor: pointer;" @click="GoToIndex">
          <span>{{ control.title[0] }}</span>
        </div>
        <div class = "Version" style="color: white;">{{ control.title[1] }}</div>
      </div>
      <div class = "Logo">
        <div><img src = "/icon/user.svg" style = "width: 20px;"></div>
        <div class = "Name UserGreeting" style = "color: var(--ccs-primary-font-color); cursor: pointer;" @click="GoToProfile">
          <span>Hey, {{ userInfo.nickname || userInfo.userName }}</span>
        </div>
        <div class = "QuitIcon">
          <img src = "/icon/quit.svg" style = "width: 20px;">
        </div>
        <div class = "Name SystemButton QuitText" style = "color: var(--ccs-primary-font-color)" @click = "Quit">
          <span>退出</span>
        </div>
      </div>
    </div>
    <div class = "Main">
      <!-- 文件导航 -->
      <div class = "Navigate">
        <FileManager ref="FileManager"
          :currentUrlSlug="$route.query.urlSlug"
          @manage-tag="__GetTag"
          @show-dialog="ShowDialog"
          @close-dialog="control.dialog.state = false"
          @close-note="CloseNote"
          @save-note="SaveNote"
          @node-removed="HandleNodeRemoved">
        </FileManager>
      </div>
      <!-- 编辑器 -->
      <div class = "Editor">
        <div class = "Info">
          <div style = "text-align: center;">
            <div style = "padding-bottom: 5px; margin-top: -50px;">
              <span style = "font-weight: 900;">欢迎使用</span>
              <span style = "color: var(--ccs-primary-color); font-weight: 900;">{{ control.title[0] }}</span>
            </div>
            <span style = "background: var(--ccs-primary-color); color: #fff; border-radius: 10px; padding: 2px 8px; font-size: 10px;">{{ control.title[1] }}</span>
            <div style = "font-size: 12px; padding: 40px 20px 10px; width: 400px; text-align: left; line-height: 20px;">
              <span>这是一款基于开源插件 Vditor 二次开发的 Markdown 云笔记产品。</span>
              <span>主要用于为个人内容存储、编辑等场景。</span>
              <span>与其他云笔记产品相比，本产品削减了绝大部分的功能 ——— 让笔记回归本质。</span>
              <div style = "color: var(--ccs-primary-color); font-weight: 900; text-align: center; font-size: 16px; padding: 10px 0;">
                <span>&gt;&gt;&gt; 记录 和 检索 &lt;&lt;&lt;</span>
              </div>
              <span>由于维护的能力、时间、服务器资源有限，仅用于个人学习、研究、使用。</span>
            </div>
            <div style = "display: flex; justify-content: center; padding-top: 30px;">
              <button class = "ControlButton" style = "color: var(--ccs-primary-color);" @click = "GetSourceCode">获取源码</button>
              <button class = "ControlButton" style = "margin-left: 10px; background: var(--ccs-primary-color); color: #fff;" @click = "() => { $refs.FileManager.AddDocNode(0, 1) }">新建笔记</button>
            </div>
          </div>
        </div>
        <!-- 编辑器路由 -->
        <router-view v-slot="{ Component }">
          <component :is="Component" ref="NoteView" 
            @SaveNote="SaveNote" 
            @EditorFocus="EditorFocus" 
            @UpdateTitle="HandleTitleUpdate"
            @RenameNode="HandleRenameNode"
            @refresh-doc-tree="RefreshDocTree" />
        </router-view>
      </div>
    </div>
    <!-- 通用对话框 -->
    <Dialog v-if = "control.dialog.state" :title = "control.dialog.title"
      :acceptName = "control.dialog.buttonName.accept"
      :cancelName = "control.dialog.buttonName.cancel"
      :content = "control.dialog.content"
      :icon = "control.dialog.icon"
      :accept = "control.dialog.accept"
      @dialogCancel = "control.dialog.state = false">

      <!-- 标签管理 -->
      <div v-if = "control.dialog.name === 'Tag'"
        class = "Dialog_Tag">
        <div v-for = "(item, index) in tagList.list" :key = "index"
          contenteditable name = "Tag" 
          @input = "item.value = $event.path[0].innerText"
          @blur = "CheckTagValue">{{ item.value }}</div>
        <button class = "ControlButton AddTag" @click = "AddTag">
          <i class = "iconfont icon-xinjian" style = "font-size: 14px;"></i>
          <span style = "padding-left: 5px;">标签</span>
        </button>
      </div>
      <!-- 通用输入框 -->
      <div v-else-if = "control.dialog.name === 'Input'" class = "Dialog_Input">
        <input v-model = "dialogInput.value" type = "text" ref = "DialogInput"
          :placeholder = "dialogInput.placeholder"
          @keydown.enter = "control.dialog.accept">
      </div>
    </Dialog>
  </div>
</template>

<script>
import TreeItem from '../components/TreeItem.vue'
import Dialog from '../components/Dialog.vue'
import FileManager from '../components/FileManager.vue'
export default {
  components: { TreeItem, Dialog, FileManager },
  data () {
    return {
      isSidebarOpen: true,
      control: {
        title: [],
        file: {
          state: {}
        },
        dialog: {
          state: false,
          title: '提示',
          content: '',
          name: '',
          icon: '/icon/warning.svg',
          buttonName: { accept: '继续', cancel: '再想想' }
        }
      },
      userInfo: { userName: '', nickname: '' },
      tagList: {
        id: '',
        list: []
      },
      dialogInput: {
        value: '',
        placeholder: ''
      }
    }
  },
  methods: {
    GoToIndex: function () {
      this.$router.push('/Index')
    },
    ToggleSidebar: function () {
      this.isSidebarOpen = !this.isSidebarOpen
    },
    ShowDialog: function (options) {
      this.control.dialog = {
        state: true,
        ...options
      }
      if (options.name === 'Input') {
        this.dialogInput.value = options.value || ''
        this.dialogInput.placeholder = options.placeholder || ''
        const originalAccept = options.accept
        this.control.dialog.accept = () => {
          if (originalAccept) originalAccept(this.dialogInput.value)
          this.control.dialog.state = false
        }
        this.$nextTick(() => { this.$refs.DialogInput.focus() })
      }
    },
    HandleNodeRemoved: function (id) {
      if (this.$route.query.id == id) {
        this.$router.push('/Index')
      }
    },
    AutoLogin: function () {
      const userName = this.$cookie.get('userName') || ''
      const nickname = this.$cookie.get('nickname') || ''
      const token = localStorage.getItem('token') || ''
      if (token === '') {
        this.Quit()
      } else {
        // 直接使用本地存储的用户名，并尝试获取文档树
        // 如果 Token 失效，GetDocTree 内部的请求会触发 main.js 中的 401 拦截器自动跳转
        this.userInfo.userName = userName
        this.userInfo.nickname = nickname
        this.$nextTick(() => {
          this.$refs.FileManager.GetDocTree(false, true)
        })
      }
    },
    __GetTag: function (id) {
      this.$Common.ApiList(this, 'TagList').then(url => {
        this.$Common.SetLoading('正在获取笔记标签列表...')
        this.axios.post(url, { data: { id } }).then(res => {
          const resData = res.data
          const state = resData.State
          if (state[0] === '20000') {
            this.tagList = { id, list: resData.Data.list }
            this.control.dialog = {
              state: true,
              title: '标签管理',
              content: '',
              name: 'Tag',
              icon: '/icon/addTag.svg',
              buttonName: { accept: '提交', cancel: '再想想' },
              accept: () => { this.__Tag() }
            }
          }
          this.$Common.RemoveLoading()
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    __Tag: function () {
      this.$Common.ApiList(this, 'TagUpdate').then(url => {
        this.$Common.SetLoading('正在更新笔记标签...')
        this.axios.post(url, { data: this.tagList }).then(res => {
          if (res.data.code === 200) {
            this.control.dialog.state = false
            this.$refs.FileManager.GetDocTree()
          }
          this.$Common.RemoveLoading()
        }).catch(() => { this.$Common.NetworkErrorDialog(this) })
      })
    },
    AddTag: function () {
      this.tagList.list.push({ value: '' })
      this.$nextTick(() => {
        const tagObjList = document.getElementsByName('Tag')
        tagObjList[tagObjList.length - 1].focus()
      })
    },
    CheckTagValue: function () {
      let newTagList = []
      this.tagList.list.forEach(element => {
        if (element.value !== '') {
          newTagList.push({ value: element.value.replace(/[^\u4e00-\u9fa50-9A-Za-z]/g, '') })
        }
      })
      this.tagList.list = newTagList
    },
    GetNote: function (id) {
      if (this.$route.query.id !== id) {
        this.$Common.SetLoading('正在载入 Markdown 组件包, 请稍候...')
        this.$router.push('/Index/Note?id=' + id).then(() => {
          this.$Common.RemoveLoading()
        })
      }
    },
    RefreshDocTree() {
      if (this.$refs.FileManager) {
        this.$refs.FileManager.GetDocTree(false, false)
      }
    },
    CloseNote: function () {
      this.$router.push('/Index')
    },
    CleanSearch: function () {
      this.filter.search = ''
      this.$nextTick(() => { this.GetDocTree() })
    },
    SaveNote: function (urlSlug) {
      // 这里的 SaveNote 原本是重复发送请求，导致并发冲突且缺少 versionLock
      // 现在由 Note.vue 内部全权负责保存逻辑
      // 这里只需要处理一些清理工作，或者干脆什么都不做（Note.vue 也会清理缓存）
      // 也就是当 Note.vue 发出 SaveNote 事件时，父组件不再重复请求
      console.log('Index.vue received SaveNote event for:', urlSlug)
      
      /* 
      this.$Common.ApiList(this, 'SaveNote').then(url => {
        const payload = {
          urlSlug: urlSlug,
          content: this.$refs.NoteView.$refs.NoteEditor.value.getValue()
        }
        this.axios.post(url, payload).then(res => {
          if (res.data.code === 200) {
            localStorage.removeItem('Note_' + urlSlug)
          }
        })
      })
      */
    },
    Quit: function () {
      this.$cookie.remove('userName')
      this.$cookie.remove('nickname')
      this.$cookie.remove('password')
      this.Logout()
    },
    GoToProfile: function () {
      this.$router.push('/Index/Profile')
    },
    Logout: function () {
      localStorage.removeItem('token')
      this.$router.push('/Login')
    },
    GetSourceCode: function () {
      window.open('https://gitee.com/Yogurt_cry/ccs-note')
    },
    EditorFocus: function (id) {
      this.control.file.state[id] = { state: true, message: null }
    },
    HandleTitleUpdate: function ({ urlSlug, title }) {
      if (this.$refs.FileManager) {
        this.$refs.FileManager.UpdateNodeNameByUrlSlug(urlSlug, title)
      }
    },
    HandleRenameNode: function ({ id, nodeName }) {
      this.$Common.ApiList(this, 'DocTreeUpdate').then(url => {
        this.axios.post(url, { id, nodeName }).then(res => {
          if (res.data.code !== 200) {
            console.error('Rename failed:', res.data.message)
          }
        }).catch(err => {
          console.error('Rename network error:', err)
        })
      })
    }
  },
  mounted () {
    this.$Common.SetDocTitle(this)
    this.AutoLogin()
  }
}
</script>

<style scoped>
  .Index {
    position: absolute;
    width: 100%;
    height: 100%;
    background: var(--ccs-primary-background-color);
    --titleHeight: 50px;
    --searchHeight: 94px;
    --fileItemIconWidth: 25px;
    --navigateWidth: 300px;
  }
  .Title {
    --padding: 16px;
    --paddingTop: 5px;
    width: 100%;
    height: var(--titleHeight);
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 var(--padding);
    padding-top: var(--paddingTop);
    background: #f7f7f7;
    color: var(--ccs-primary-font-color);
    font-size: 14px;
    font-weight: unset;
    position: absolute;
    top: 0;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    z-index: 2;
    border-bottom: 1px solid #eee;
  }
  .Title .Logo {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .Title .Name {
    padding: 0 0 5px 8px;
    cursor: pointer;
  }
  .Title .UserGreeting:hover {
    color: #409eff !important;
  }
  .Title .SystemButton:hover {
    color: var(--ccs-primary-color) !important;
    font-weight: 900;
  }
  .Title .SystemButton:active {
    color: var(--ccs-button-hover-color) !important;
  }
  .Version {
    background: var(--ccs-primary-color);
    border-radius: 10px;
    color: var(--ccs-primary-font-color);
    padding: 0px 5px 1px 5px;
    font-size: 10px;
    margin-bottom: 4px;
    margin-left: 8px;
  }
  .Main {
    position: absolute;
    width: 100%;
    height: calc(100% - var(--titleHeight));
    top: var(--titleHeight);
  }
  .Main .Navigate {
    width: var(--navigateWidth);
    height: 100%;
    background: #f7f7f7;
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
    z-index: 1;
    position: relative;
    border-right: 1px solid #eee;
    overflow: hidden;
    transition: width 0.3s ease;
  }
  .Main .Editor {
    position: absolute;
    left: var(--navigateWidth);
    top: 0;
    width: calc(100% - var(--navigateWidth));
    height: 100%;
    z-index: 0;
    transition: left 0.3s ease, width 0.3s ease;
  }
  .SidebarCollapsed {
    --navigateWidth: 0px;
  }
  .SidebarCollapsed .Main .Navigate {
    border-right: none;
    box-shadow: none;
  }
  .QuitIcon {
    padding-left: 20px;
    display: flex;
    align-items: center;
  }

  @media screen and (max-width: 768px) {
    .Title {
      --padding: 5px;
    }
    .QuitIcon {
      padding-left: 5px;
    }
    .UserGreeting {
      max-width: 80px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .QuitText {
      display: block !important;
      white-space: nowrap;
    }
    .Version {
      display: none;
    }
  }
  .Main .Editor .Info {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--ccs-primary-font-color);
  }
  .Dialog_Tag div {
    border: unset;
    background: #252526;
    padding: 10px 20px;
    margin-bottom: 10px;
    border-radius: 30px;
    color: var(--ccs-primary-font-color);
  }
  .Dialog_Tag div:focus-visible {
    outline: 2px solid var(--ccs-primary-color);
  }
  .Dialog_Tag div {
    width: auto;
    margin-right: 10px;
  }
  .Dialog_Tag {
    display: flex;
    flex-wrap: wrap;
  }
  .Dialog_Tag .AddTag {
    cursor: pointer;
    background: var(--ccs-primary-color);
    margin-bottom: 10px;
    padding: 7px 15px 8px 15px;
  }

  .Dialog_Input {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .Dialog_Input input {
    width: 100%;
    padding: 10px 15px;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f9f9f9;
    color: #333;
    outline: none;
    font-size: 14px;
  }
  .Dialog_Input input:focus {
    border-color: var(--ccs-primary-color);
    background: #fff;
  }
  /* Mobile Layout */
  @media screen and (max-width: 768px) {
    .Index {
      --navigateWidth: 260px;
    }
    
    .Title {
      font-size: 12px;
      --padding: 10px;
      flex-wrap: wrap; /* Allow wrapping */
      height: auto;    /* Auto height */
      padding-bottom: 5px;
    }
    
    .Title .Logo {
      margin-bottom: 5px; /* Spacing for wrapped items */
    }

    .Title .Logo:last-child {
      margin-left: auto; /* Push user info to right */
    }
    
    .Main {
      top: 50px; /* Adjust top offset if needed, or keep dynamic */
      height: calc(100% - 50px);
    }
    
    .Main .Navigate {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 10;
      transform: translateX(0);
      transition: transform 0.3s ease;
      box-shadow: 2px 0 8px rgba(0,0,0,0.1);
    }
    
    /* When sidebar is collapsed on mobile, hide it by moving it off-screen */
    .SidebarCollapsed .Main .Navigate {
      transform: translateX(-100%);
      width: var(--navigateWidth); /* Keep width, just move it */
    }
    
    .Main .Editor {
      left: 0 !important;
      width: 100% !important;
    }
    
    .Title .Logo {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-right: 10px;
    }
    
    /* Hide non-essential buttons on mobile */
    .Title .Logo div[style*="padding-left"] {
      padding-left: 10px !important;
    }
    
    .Title .Logo .SystemButton span {
      display: none; /* Hide text, show icon only */
    }
    
    .Title .Logo .SystemButton {
      padding: 0 5px;
    }
    
    .Title .Name {
      max-width: 100px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    .Main .Editor .Info {
      padding: 20px;
      box-sizing: border-box;
    }
    
    .Main .Editor .Info > div {
      width: 100%;
      max-width: 400px;
    }
    
    .Main .Editor .Info div[style*="width: 400px"] {
      width: 100% !important;
    }
  }
</style>
